import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./api/apiSlice";
import apiRequestStatusReducer, {
	apiRequestStatusMiddleware,
} from "../features/api-request-status/apiRequestStatusSlice";
import authReducer from "../features/auth/authSlice";
import setPasswordReducer from "../features/set-password/setPasswordSlice";
import loanDocsReducer from "../features/loan-docs/loanDocsSlice";
import brokerListReducer from "../features/broker-list/brokerListSlice";
import impersonatedUserReducer from "../features/admin/impersonated-user/impersonatedUserSlice";
import sameAsCurrentAddressReducer from "../features/same-as-current-address/sameAsCurrentAddressSlice";
import brokerUploadedDocsReducer from "../features/broker-uploads/brokerUploadSlice";
import lockRequestLogReducer from "../features/lock-request-log/lockRequestLogSlice";
import categoryConditionReducer from "../features/category-condition/categoryConditonSlice";
import enhancedConditionStatusReducer from "../features/enhanced-condition-status/enhancedConditionStatusSlice";
import underwritingConditionsReducer from "../features/underwriting-conditions/underwritingSlice";
import preliminaryConditionsReducer from "../features/preliminary-conditions/preliminarySlice";
import postClosingConditionsReducer from "../features/post-closing-conditions/postClosingSlice";
import fieldValuesReducer from "../features/field-values/fieldValueSlice";
import conditionStatusReducer from "../features/condition-status/conditionStatusSlice";
import enhancedConditionsDocumentsListByCategoriesReducer from "../features/fetch-enhanced-conditions-documents-list-by-category/fetchEnhancedConditionsDocumentsListByCategory";
import enhancedConditionsDocumentsListReducer from "../features/enhanced-conditions-documents_list/enhancedConditionsDocumentsListSlice";

import quickPricerFormReducer from "../features/quickPricer/quickPricerFormSlice";
import currentLoanReducer from "../features/current-loan/currentLoanSlice";
import { storageDelete } from "../utils/localStorage";

const CURRENT_LOAN_KEY = "current-loan-progress";

const combinedReducers = combineReducers({
	[apiSlice.reducerPath]: apiSlice.reducer,
	auth: authReducer,
	setPassword: setPasswordReducer,
	loanDocs: loanDocsReducer,
	brokerList: brokerListReducer,
	impersonatedUser: impersonatedUserReducer,
	sameAsCurrentAddress: sameAsCurrentAddressReducer,
	brokerUploadedDocs: brokerUploadedDocsReducer,
	lockRequestLog: lockRequestLogReducer,
	categoryCondition: categoryConditionReducer,
	enhancedConditionStatus: enhancedConditionStatusReducer,
	underwritingConditions: underwritingConditionsReducer,
	preliminaryConditions: preliminaryConditionsReducer,
	postClosingConditions: postClosingConditionsReducer,
	fieldValues: fieldValuesReducer,
	conditionStatus: conditionStatusReducer,
	enhancedConditionsDocumentsListByCategories: enhancedConditionsDocumentsListByCategoriesReducer,
	enhancedConditionsDocumentsList: enhancedConditionsDocumentsListReducer,
	apiRequestStatus: apiRequestStatusReducer,
	quickPricerForm: quickPricerFormReducer,
	currentLoan: currentLoanReducer,
});

const rootReducer = (state, action) => {
	if (action.type === "auth/logOut") {
		// Clear persisted loan progress on logout — prevents cross-user data exposure
		// on shared browsers where User B would otherwise see User A's loan data.
		storageDelete(CURRENT_LOAN_KEY);
		return combinedReducers(undefined, action);
	}
	return combinedReducers(state, action);
};

export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(
			apiRequestStatusMiddleware,
			apiSlice.middleware
		),
	devTools: true,
});
